module.exports = __webpack_public_path__ + "static/media/ic-column-add-left.fe15fc91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/table-icons/ic-column-add-left.svg
// module id = 820
// module chunks = 17